import { Trans } from '@lingui/react/macro'
import { type DocumentTableRow } from 'features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns'
import { FavoriteDocumentCard } from 'features/knowledgeDocumentViewer/components/advancedSearch/components/recents/FavoriteDocumentCard'
import { RecentChartCard } from 'features/knowledgeDocumentViewer/components/advancedSearch/components/recents/RecentChartCard'
import { RecentItems } from 'features/knowledgeDocumentViewer/components/advancedSearch/components/recents/RecentItems'
import {
  type ChartSearchItem,
  type RecentItem,
  type SensorSearchItem,
} from 'features/knowledgeDocumentViewer/types/searchableItems'
import type { FavoriteDocument } from 'features/knowledgeDocumentViewer/utils/favoriteDocumentsStorage'
import React, { memo } from 'react'

import {
  FavoritesGrid,
  SectionContainer,
  SectionLabel,
} from './unifiedSearchLandingStyles'

export type LandingScrollSectionsProps = {
  favoriteDocuments: FavoriteDocument[]
  displayRecentDocuments: RecentItem[]
  recentCharts: RecentItem<ChartSearchItem>[]
  onFavoriteSelect: (documentId: string) => void
  onRemoveFavorite: (documentId: string) => void
  onRecentDocumentSelect: (doc: DocumentTableRow) => void
  onSensorSelect: (sensor: SensorSearchItem) => void
  onChartSelect: (chart: ChartSearchItem) => void
  favoritesDisabled?: boolean
  favoritesSaving?: boolean
  isFavorited: (id: string) => boolean
  onToggleFavorite: (document: DocumentTableRow) => void
}

export const LandingScrollSections = memo(function LandingScrollSections({
  favoriteDocuments,
  displayRecentDocuments,
  recentCharts,
  onFavoriteSelect,
  onRemoveFavorite,
  onRecentDocumentSelect,
  onSensorSelect,
  onChartSelect,
  favoritesDisabled,
  favoritesSaving,
  isFavorited,
  onToggleFavorite,
}: LandingScrollSectionsProps) {
  return (
    <>
      {favoriteDocuments.length > 0 && (
        <SectionContainer>
          <SectionLabel>
            <Trans>FAVORITES</Trans>
          </SectionLabel>
          <FavoritesGrid>
            {favoriteDocuments.map((doc) => (
              <FavoriteDocumentCard
                key={doc.id}
                document={doc}
                onClick={onFavoriteSelect}
                onRemoveFavorite={onRemoveFavorite}
                favoritesDisabled={favoritesDisabled}
                favoritesSaving={favoritesSaving}
              />
            ))}
          </FavoritesGrid>
        </SectionContainer>
      )}

      {recentCharts.length > 0 && (
        <SectionContainer>
          <SectionLabel>
            <Trans>Recent Charts</Trans>
          </SectionLabel>
          <FavoritesGrid>
            {recentCharts.map((recent) => (
              <RecentChartCard
                key={recent.item.id}
                chart={recent.item}
                onClick={onChartSelect}
              />
            ))}
          </FavoritesGrid>
        </SectionContainer>
      )}

      {displayRecentDocuments.length > 0 && (
        <SectionContainer>
          <SectionLabel>
            <Trans>Recent Documents</Trans>
          </SectionLabel>
          <RecentItems
            recentItems={displayRecentDocuments}
            onSelectDocument={onRecentDocumentSelect}
            onSelectSensor={onSensorSelect}
            onSelectChart={onChartSelect}
            favoritesDisabled={favoritesDisabled}
            favoritesSaving={favoritesSaving}
            isFavorited={isFavorited}
            onToggleFavorite={onToggleFavorite}
            fullPage
          />
        </SectionContainer>
      )}
    </>
  )
})
